module.exports = __webpack_public_path__ + "img/game_detail_cannon20_regular.7c956897.jpg";